import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  input,
  output,
  signal,
  ViewChild,
} from '@angular/core';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SvgComponent } from 'icon';

export type ButtonType =
  | 'mat-text-button'
  | 'mat-tonal-button'
  | 'mat-filled-button'
  | 'mat-outlined-button'
  | 'mat-warning-button';

@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, SvgComponent, MatButtonModule, MatIconModule],
})
export class ButtonComponent {
  public text = input<string>();
  public svg = input<string>();
  public svgClass = input<string>();
  public customButtonClass = input<string>();
  public customButtonTextClass = input<string>('');
  public type = input<ButtonType>();
  public color = input<'primary' | 'featured'>('primary');
  public disabled = input(false);
  public loading = input(false);
  public role = input<'link'>();
  public ariaLabel = input<string>();
  public clickEvent = output<void>();
  public isPressed = signal(false);
  @ViewChild('btnEl') public btnEl: MatButton;
  public bgColorClass = computed(() => {
    switch (this.color()) {
      case 'primary':
        return '![background:--color-primary-default]';
      case 'featured':
        return '![background:--color-featured]';
    }
  });

  public onButtonClick(event: MouseEvent) {
    event.stopPropagation();
    if (!this.disabled()) this.clickEvent.emit();
  }

  @HostListener('mousedown')
  public onMouseDown() {
    this.isPressed.set(true);
  }

  @HostListener('window:mouseup')
  public mouseUp() {
    this.isPressed.set(false);
  }

  public focus() {
    setTimeout(() => this.btnEl?.focus());
  }
}
